module.exports = __webpack_public_path__ + "static/media/error-404-d.ac92b99a.svg";